import PropTypes from 'prop-types'
import R from 'ramda'

import { Box, Icon, Text } from '@redriverpress/system'

import Levels from './Levels'
import { cefr, clb, eld, nrs, none } from '../../constants/levels'
import { allAudiences } from '../../constants/audiences'

export default function LevelsAndAudiences({
  audiences,
  eslLevels,
  preferredLevels,
  preferredLevelType,
}) {
  // Audiences should be shown as 'All audiences' if:
  // - the item has not been tagged with any audiences, OR
  // - it has been tagged with every (permitted) audience
  const shouldBeAllAudiences = R.any(R.equals(true), [
    !audiences.length,
    R.equals(audiences, allAudiences),
  ])

  // Don't display grade band audiences for now
  const filteredAudiences = audiences.filter(a => allAudiences.includes(a))

  return (
    <Box fontSize={0} display={['block', null, 'flex']}>
      <Levels
        eslLevels={eslLevels}
        preferredLevels={preferredLevels}
        preferredLevelType={preferredLevelType}
      />
      <Box display='flex' alignItems='baseline'>
        <Icon width='1rem' pr={2} flexShrink={0} icon='user-graduate' />
        <Text>
          {shouldBeAllAudiences ? 'All ages' : filteredAudiences.join(', ')}
        </Text>
      </Box>
    </Box>
  )
}

LevelsAndAudiences.defaultProps = {
  audiences: [],
  eslLevels: [],
  preferredLevels: [],
}

LevelsAndAudiences.propTypes = {
  audiences: PropTypes.arrayOf(PropTypes.string),
  eslLevels: PropTypes.arrayOf(PropTypes.string),
  preferredLevels: PropTypes.arrayOf(PropTypes.string),
  preferredLevelType: PropTypes.oneOf([cefr, clb, eld, nrs, none]).isRequired,
}
